import React,{useEffect,useState} from 'react'
import {connect,useHistory} from 'umi'
import './index.less'
function Index(props:any) {
    const history = useHistory()
    const { dispatch,
        BouncedName,
        BouncedBtn,
        btn_src } = props;
    const [flag,setFlag] = useState(false)
    useEffect(() => {
        setFlag(true)
       setTimeout(()=>{
        setFlag(false)
        setTimeout(()=>{
            dispatch({
                type:'headInfo/changeBounced',
                payload:{
                    BouncedFlag:false,
                    BouncedName:'',
                    BouncedBtn:'',
                    btn_src:''
                }
            })
        },500)
       },3000)
    }, [])
    return (
        <>
        
           <div className={flag?'bounced_box':'bounced_box_bottom'}>
            <span className='text_left'>
            {BouncedName}
            </span>
            {
                BouncedBtn?<span onClick={()=>{
                    history.push(btn_src)
                }} className='View_right'>
                {BouncedBtn}
            </span>:<span className='View_right'>
               
            </span>
            }
            
        </div>
        
        
        </>
        
    )
}

export default connect(({ headInfo }: any) => {
    return{
      ...headInfo,
    }
  })(Index);
